<template>
  <div class="city-select">
    <vs-row>
      <vs-col>
        <h6>Selecione o estado</h6>
      </vs-col>
    </vs-row>
    <vs-row vs-justify="center" vs-align="flex-start">
      <whole-multiselect
        title="Estado"
        :options="states"
        placeholder="Estado"
        v-model="state"
        :showText="true"
        label="nome"
        class="select"
        @input="sendState()"
      />
    </vs-row>
    <vs-row>
      <vs-col>
        <h6>Selecione a cidade</h6>
      </vs-col>
    </vs-row>
    <vs-row vs-justify="center" vs-align="flex-start">
      <whole-multiselect
        title="Cidade"
        :options="cities"
        placeholder="Cidade"
        v-model="city"
        :showText="true"
        label="nome"
        class="select"
        @input="sendCity()"
        :disabled="desableCity"
      />
    </vs-row>
  </div>
</template>
<script>
import mixins from "@/Mixins.js";
import WholeMultiselect from "@/components/whole-multiselect/WholeMultiselect.vue";

export default {
  mixins: [mixins],
  components: {
    WholeMultiselect,
  },
  data() {
    return {
      window: {
        width: 0,
        height: 0,
      },
      cities: [],
      states: [],
      stateValue: "",
      desableCity: true,
    };
  },
  props: {
    city: {
      type: Object,
      default() {
        return {
          id: null,
          text: null,
        };
      },
      required: false,
    },
    state: {
      type: Object,
      default() {
        return {
          id: null,
          text: null,
          sigla: null,
        };
      },
      required: false,
    },
    showShortName: {
      type: Boolean,
      default: false,
      required: false,
    },
  },

  created() {
    const vm = this;
    vm.getStates();
  },

  mounted: function () {
    const vm = this;
    if (vm.state != null) {
      vm.getCities();
    }
  },

  watch: {
    "state.id": function () {
      const vm = this;
      vm.getCities();
    },
  },

  methods: {
    getCities() {
      const vm = this;
      vm.axios
        .get(
          "https://servicodados.ibge.gov.br/api/v1/localidades/estados/" +
            vm.state.sigla +
            "/municipios?orderBy=nome",
          {
            headers: { Authorization: vm.$session.get("bearer") },
          }
        )
        .then(function (response) {
          if (response.status === 200) {
            vm.cities = [];
            for (var i in response.data)
              vm.cities.push({
                id: response.data[i].id,
                text: response.data[i].nome,
              });
          }
        });
      vm.desableCity = false;
    },

    sendCity() {
      const vm = this;
      vm.$emit("update-city", vm.city);
      vm.$nextTick(() => {
        vm.removeFocus();
      });
    },

    sendState() {
      const vm = this;
      vm.$emit("update-state", vm.state);
      vm.getCities();
      vm.$nextTick(() => {
        vm.removeFocus();
      });
      vm.city = null;
    },

    getStates() {
      const vm = this;
      vm.axios
        .get(
          "https://servicodados.ibge.gov.br/api/v1/localidades/estados?orderBy=nome",
          {
            headers: { Authorization: vm.$session.get("bearer") },
          }
        )
        .then(function (response) {
          if (response.status === 200) {
            for (var i in response.data)
              vm.states.push({
                id: response.data[i].id,
                text: vm.showShortName ? response.data[i].sigla : response.data[i].nome,
                sigla: response.data[i].sigla,
              });
          }
        });
      vm.city = null;
    },

    removeFocus() {
      document.activeElement.blur();
    },

    clearFields() {
      const vm = this;
      vm.$nextTick(() => {
        vm.removeFocus();
      });
    },
  },
};
</script>
<style lang="scss">
.city-select {
  background-color: rgb(243, 240, 240);
  border-radius: 10px;
  margin: 10px 10px 0px 0px !important;
  padding: 20px 40px 20px 20px !important;
  .search {
    margin-top: 40px;
    min-width: 40px;
  }
  .clear {
    margin-left: 10px;
  }
  .vs-input {
    .vs-con-input {
      background-color: white;
    }
  }
}
</style>
